import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import Catalog from '../components/Catalog';
import Layout from '../components/Layout';
import { useTour } from '../provider/TourGuide';
import introJs from 'intro.js';
import { CatalogPage as Tour } from '../enums/tourEnums';

const CatalogPage = () => {
  const {
    onExitCatalog,
    setEnabledCatalog,
    enabledCatalog,
    setCatalogNumber,
  } = useTour();

  useEffect(() => {
    if (!localStorage.getItem('catalog')) {
      setEnabledCatalog(true);
    }
  }, [setEnabledCatalog]);

  useEffect(() => {
    if (enabledCatalog && !localStorage.getItem('catalog')) {
      const intro = introJs()
        .onafterchange(() => {
          const stepIndex = intro._currentStep;
          setCatalogNumber(stepIndex + 1);
        })
        .onbeforechange(() => {
          const stepIndex = intro._currentStep;
          console.log('stepIndex',stepIndex)
          setCatalogNumber(stepIndex - 1);
          return true
        })
        .oncomplete(() => {
          localStorage.setItem('catalog', 'true');
          setCatalogNumber(0);
          setEnabledCatalog(false);
          localStorage.removeItem('catalog');
          onExitCatalog();
        })
        .onexit(() => {
          localStorage.setItem('catalog', 'true');
          setCatalogNumber(0);
          setEnabledCatalog(false);
          localStorage.removeItem('catalog');
          onExitCatalog();
        });
  
      intro.setOptions({
        ...Tour,
        scrollToElement: false,
        disableInteraction: true,
      });
      intro.start();
    }
  }, [enabledCatalog]);

  return (
    <Layout>
      <Catalog.Filter />
      <Catalog.LastOrders />
      <Catalog.Options />
      <Catalog.CatalogList />
    </Layout>
  );
};

export default CatalogPage;
